// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { showModal } from '../redux/main/actions/modal';

type OwnProps = {
  type: 'warning' | 'danger',
  title?: string,
  buttonText: string,
  body: React.Node,
  onConfirm: () => Promise<mixed>,
  render: ({ showModal: () => void }) => React.Node,
  'data-qa-id'?: string
};

type Props = {
  ...$Exact<OwnProps>,
  showModal: typeof showModal
};

type State = {
  submitting: boolean
};

class ShowConfirmationModal extends React.Component<Props, State> {
  showModal = () => {
    const { type, title, buttonText, body, onConfirm } = this.props;
    this.props.showModal('CONFIRMATION', {
      type,
      title,
      buttonText,
      body,
      onConfirm,
      'data-qa-id': this.props['data-qa-id']
    });
  };

  render() {
    return this.props.render({ showModal: this.showModal });
  }
}

export default connect<Props, OwnProps, _, _, _, _>(
  null,
  { showModal }
)(ShowConfirmationModal);
